import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';

//Style
import style from "../../../Style/Component/portfolio.module.scss";

//Custom components
import { TextButton } from '../../../Components/Buttons';
import { OrderCard } from '../../../Components/Card';
import { ActiveSipModal, OrderHistoryModal } from '../../../Components/Modal';

const BasketDetail = (props) => {


    const [toggleXIRR, setToggleXIRR] = useState(true);
    const [toggleValue, setToggleValue] = useState(false);

    const [showOrderHistoryModal, setShowOrderHistoryModal] = useState(false);
    const [showActiveSipModal, setShowActiveSipModal] = useState(false);

    useEffect(() => {
        if (showOrderHistoryModal) {
            var modal = new Modal(document.getElementById("order-history-modal"));
            modal.show();
        }
    }, [showOrderHistoryModal]);

    useEffect(() => {
        if (showActiveSipModal === true) {
            var modal = new Modal(document.getElementById("active-sip-modal"));
            modal.show();
        }
    }, [showActiveSipModal]);
    
    // handle toggle 
    const _handleToggleXIRR = () => {
        setToggleXIRR(prev => !prev);
    };

    // handle toggle 
    const _handleToggle = () => {
        setToggleValue(prev => !prev);
    };


    return (
        <div className={style.e_portfolio_wrapper}>
            {/* <div className=' d-flex gap-3 align-items-center cursor-pointer w-max-content'
                onClick={() => props.handleBack()}>
                <Icon icon="back"
                    className="d-flex"
                    color="#292D32"
                    size={32} />
                <span className='e-text-custom-blue e-alt-font e-font-18 e-font-weight-600 line-height-22px'>
                    {props.data.dashboard?.name}
                </span>
            </div> */}

            <div className='row pt-1'>
                <div className='col-6 d-flex flex-column gap-4'>
                    <div className={`${style.e_detail_data_card_wrapper} e-bg-white  border-radius-12 py-3 pe-3`}>
                        <div className='d-flex align-items-center justify-content-between gap-3 mb-2 pb-1'>
                            <p className='ribbon-bg e-text-dark-gray e-alt-font e-font-12 e-font-weight-600 mb-0'>
                                {props.data.dashboard?.name}
                            </p>
                            <div className='d-flex gap-1 align-items-center justify-content-end  mb-xxl-0   cursor-pointer'
                                onClick={_handleToggleXIRR}>
                                <p className="mb-0 w-max-content e-text-princeton-orange e-alt-font e-font-14 e-font-weight-600 line-height-16px">
                                    {toggleXIRR ? "XIRR" : "Absolute"} (%)
                                </p>
                                <img src={require("../../../Assets/Image/Others/arrow-toggle.svg").default}
                                    alt='arrow toggle' />
                            </div>
                        </div>
                        <div className='ps-3'>
                            <div className="row flex-column gap-12px">
                                <div className='col'>
                                    <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Current Value
                                        <span className='e-font-16 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                            {props.data?.dashboard?.current_amount_text || "-"}
                                        </span>
                                    </p>
                                </div>


                                <div className='col'>

                                    <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Invested Amount
                                        <span className='e-font-16 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                            {props.data?.dashboard?.invested_amount_text || "-"}
                                        </span>
                                    </p>

                                </div>
                                <div className='col'>
                                    <div className='d-flex justify-content-between'>
                                        <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                                            {toggleXIRR ? "XIRR Returns" : "Absolute Returns"}
                                        </p>
                                        <p className={`${props.data?.dashboard?.returns_amount > 0 ? "e-text-success" : props.data?.dashboard?.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.dashboard?.returns_amount_text || "-"}
                                            {
                                                toggleXIRR ?
                                                    <span className={`${props.data.dashboard.xirr > 0 ? "e-text-success" : props.data.dashboard.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.dashboard.xirr_text})</span>
                                                    :
                                                    <span className={`${props.data.dashboard.returns_percentage > 0 ? "e-text-success" : props.data.dashboard.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.dashboard.returns_percentage_text})</span>
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className='d-flex justify-content-between'>
                                        <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                                            1 Day Change
                                        </p>
                                        <p className={`${props.data?.dashboard?.one_day_returns > 0 ? "e-text-success" : props.data?.dashboard?.one_day_returns < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.dashboard?.one_day_returns_text || "-"}
                                            <span className={` e-font-16 e-font-weight-600  line-height-18px`}>
                                                ({props.data?.dashboard?.one_day_returns_percentage_text || "-"})
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Overview */}
                    <div className='d-flex flex-column gap-2'>
                        {/* Overview */}
                        {Object.keys(props.activeSip).length !== 0 &&
                            <>
                                {props.activeSip?.data?.sips.slice(0, 2).map((sip, index) => (
                                    <div key={index} className={`${style.e_detail_data_card_wrapper} e-bg-white border-radius-12 p-4`}>
                                        <div className='d-flex justify-content-between align-items-start position-relative'>
                                            <h6 className='mb-0 e-text-dim-black e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                                SIP Amount
                                            </h6>

                                            <p className='mb-0 e-text-blue-violet e-alt-font e-font-18 e-font-weight-600 line-height-22px'>
                                                {sip?.amount_text || '-'}
                                            </p>

                                        </div>
                                    </div>
                                ))}

                                {props.activeSip?.data?.sips?.length > 2 &&
                                    <div className='text-end d-flex justify-content-end' >
                                        <TextButton name="View all"
                                            className="e-font-weight-600 e-font-16 text-decoration-underline text-center mx-auto"
                                            onClick={() => {
                                                setShowActiveSipModal(true);
                                            }} />
                                    </div>
                                }
                            </>
                        }
                    </div>


                    {/* Balanced basket */}
                    <div className={`${style.e_detail_data_card_wrapper} e-bg-white p-4 border-radius-12 flex-fill`}>
                        <div className=''>
                            <h6 className='mb-3 e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                Asset allocation
                            </h6>

                            <div>
                                <div className="d-flex justify-content-between pb-1">
                                    <div className='e-alt-font e-font-weight-400 e-font-14 line-height-14px e-text-mid-gray'>0</div>
                                    <div className='e-alt-font e-font-weight-400 e-font-14 line-height-14px e-text-mid-gray'>100%</div>
                                </div>
                                {/* percentage div */}
                                <div className='progress-stacked border-radius-12 h-36px'>
                                    {props.data?.grap_data?.map((item, index) => (
                                        <div key={index} className="progress h-100"
                                            style={{ width: item.value + "%" }}
                                            role="progressbar"
                                            aria-label="Baskets allocation"
                                            aria-valuenow="75"
                                            aria-valuemin="0"
                                            aria-valuemax="100">
                                            <div className="progress-bar h-100" style={{ background: item.color }}></div>
                                        </div>
                                    ))
                                    }
                                </div>

                                <div className='pt-3 d-flex gap-4'>
                                    {props.data?.grap_data?.map((percentage, index) => (
                                        <div key={index}
                                            className='d-flex align-items-center gap-4px '>
                                            <div className={`w-8px h-8px rounded `} style={{ background: percentage.color }}></div>
                                            <div className='e-alt-font  e-font-weight-400 e-font-14 line-height-14px'>{percentage.label}:
                                                <span className='e-font-weight-700 ps-1'>{percentage.value_text}</span>
                                            </div>
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>

                            {/* Funds  */}
                            <div className='pt-4 mt-2 '>
                                <div className='row'>
                                    <div className='col-7'>
                                        <p className='mb-0 e-text-dark-gray e-alt-font e-font-16 e-font-weight-400 line-height-18px'>
                                            Funds
                                        </p>
                                    </div>

                                    <div className='col-5'>
                                        <div className='d-flex align-items-center justify-content-end gap-2px cursor-pointer'
                                            onClick={_handleToggle}>
                                            <p className='mb-0 e-text-princeton-orange e-alt-font e-font-16 e-font-weight-600 line-height-18px'>
                                                {toggleValue ? 'Invested value' : 'Current value'}
                                            </p>
                                            <img src={require("../../../Assets/Image/Others/arrow-toggle.svg").default}
                                                draggable={false}
                                                alt='arrow' />
                                        </div>
                                    </div>
                                </div>

                                {/* fund list */}
                                {
                                    props.data?.funds?.map((item, index) => (
                                        <div className={`pb-2 ${index > 0 ? "e-border-top-1px-bright-gray-light" : ""}`} key={index}>
                                            <div className='row pt-3'>
                                                <div className='col-9'>
                                                    <div className='pb-2 d-flex align-items-center gap-12px'>

                                                        <div className="e-bg-white border-radius-6 e-border-1px-solid-bright-gray-dark p-1">
                                                            <img src={item.image}
                                                                alt={"fund logo"}
                                                                width={28}
                                                                height={28}
                                                                className='e-fund-card-banner object-fit-contain border-radius-6' />
                                                        </div>
                                                        <p className='mb-0 e-text-truncate e-text-dark-gray e-alt-font e-font-14 e-font-weight-400 line-height-20px'>
                                                            {item.fund_name}
                                                        </p>
                                                    </div>
                                                    <p className='mb-0 e-text-dark-gray e-alt-font e-font-12 e-font-weight-400 line-height-14px'>
                                                        Allocation: <span className='e-font-weight-600 e-text-blue-violet'>{item.allocation}%</span>
                                                    </p>
                                                </div>

                                                <div className='col-3 text-end'>
                                                    <p className='mb-2 e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-18px'>
                                                        {toggleValue ? item.invested_amount_text : item.current_amount_text}
                                                    </p>
                                                    <p className={`${item.returns_percentage > 0 ? "e-text-success" : item.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} mb-0 e-alt-font e-font-14 e-font-weight-600 line-height-16px`}>
                                                        ({item.returns_percentage_text})
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {/* <div className='pt-4 text-center'>
                                <SecondaryButton name="View Order History"
                                    paddingBlock="padding-12px-tb px-3" />
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className='col-6'>
                    {props.historyLoader === false && props.orderHistory?.orders?.length !== 0 &&
                        <div className={`${style.e_detail_data_card_wrapper}  e-bg-white border-radius-12 p-4   `}>
                            <div className='d-flex flex-column row-gap-3 align-items-start position-relative'>
                                <h6 className='mb-1 e-text-custom-blue e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                    Order History
                                </h6>

                                <div className="d-flex flex-column gap-3 w-100">
                                    {
                                        props.orderHistory.orders.slice(0, 5).map((item, index) => <OrderCard key={index} order={item} />)
                                    }
                                </div>

                            </div>

                            {props.orderHistory.orders.length > 4 &&
                                <div className='text-center pt-4 mt-2' >
                                    <TextButton name="View all order history"
                                        className="e-font-weight-600 e-font-16 text-decoration-underline text-center mx-auto"
                                        onClick={() => {
                                            setShowOrderHistoryModal(true);
                                            props.handleViewHistory();
                                        }} />
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>

            {showOrderHistoryModal &&
                <OrderHistoryModal
                    orderHistory={props.modalHistoryData.orders}
                    currentPage={props.modalHistoryData.current_page}
                    totalPage={props.modalHistoryData.total_page}
                    handleViewMore={props.handleViewMore}
                    modalHistoryLoader={props.modalHistoryLoader}
                    forcedLoader={props.forcedLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setShowOrderHistoryModal(false);
                            props.handleClose();
                        }, 200);
                    }} />
            }

            {showActiveSipModal === true &&
                <ActiveSipModal data={props.activeSip.data.sips}
                    handleClose={() => {
                        setTimeout(() => {
                            setShowActiveSipModal(false);
                        }, 200);
                    }} />
            }
        </div>
    )
}

export default BasketDetail;
